﻿function navigate($el: Element): void {
    const link = $el.getAttribute('data-link');
    const target = $el.getAttribute('data-target');

    // Synthetic navigation, to allow for noreferrer and noopener
    if (link) {
        const $anchor = document.createElement('a');

        $anchor.href = link;
        $anchor.rel = 'noreferrer noopener';

        // External target, i.e open in another page?
        if (target) {
            $anchor.target = target;
        }

        $anchor.click();
    }
}

function registerEvents($card: Element): void {
    // If the "card" itself was clicked
    $card.addEventListener('click', (e) => {
        const isTextSelected = !!window.getSelection()?.toString();

        if (!isTextSelected && e.currentTarget) {
            navigate(e.currentTarget as Element);
        }
    });

    $card.addEventListener('keyup', (e) => {
        if (e.key == 'Enter') {
            e.preventDefault();
            navigate(e.target as Element);
        }
    });
}

/*
 * Script for accessible "cards"
 */
export function registerCards(): void {
    const $cards = document.querySelectorAll('[data-link]');

    $cards.forEach($card => registerEvents($card));
}

/**
 * Low level api to create a card dynamically
 */
export function registerCard($card: HTMLElement, url: string, title?: string | null, target?: string | null): HTMLElement {
    $card.tabIndex = 0;
    $card.setAttribute('data-link', url);

    if (title) {
        $card.title = title
        $card.setAttribute('aria-label', title);
    }

    if (target) {
        $card.setAttribute('data-target', target);
    }

    registerEvents($card);

    return $card;
}
